// extracted by mini-css-extract-plugin
export var actionButton = "_8e-1";
export var actionButtons = "_8e-2";
export var actions = "_8e-0";
export var aiUnread = "_8e-10";
export var alignCenter = "_8e-h";
export var backWrapper = "_8e-3";
export var cellContainer = "_8e-4";
export var checkboxContainer = "_8e-5";
export var contentContainer = "_8e-6";
export var contentHeader = "_8e-8";
export var conversationsTableWrapper = "_8e-s";
export var draftReplyBadgeContainer = "_8e-m";
export var dropdownItem = "_8e-b";
export var dropdownItemsContainer = "_8e-a";
export var dropdownTitle = "_8e-c";
export var errorIcon = "_8e-7";
export var filter = "_8e-d";
export var gray = "_8e-i";
export var headerActionButtons = "_8e-e";
export var headerCheckboxContainer = "_8e-f";
export var icon = "_8e-j";
export var menuContainer = "_8e-k";
export var noMoreTicketsIcon = "_8e-12";
export var noMoreTicketsSubText = "_8e-13";
export var oneLine = "_8e-l";
export var optionsButton = "_8e-n";
export var plus = "_8e-o";
export var portalButtonsWrapper = "_8e-g";
export var red = "_8e-p";
export var scrolledTop = "_8e-9";
export var search = "_8e-q";
export var selectedConversationsCount = "_8e-r";
export var spinner = "_8e-t";
export var strong = "_8e-u";
export var summaryCell = "_8e-v";
export var tableContainer = "_8e-11";
export var tagContainer = "_8e-w";
export var threeDots = "_8e-x";
export var twoLines = "_8e-y";
export var unread = "_8e-z";